"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
require("bootstrap/dist/css/bootstrap.min.css");
require("jquery-validation");
require("jquery-validation/dist/additional-methods.js");
require("../stylesheets/style.less");
require("bootstrap/dist/js/bootstrap.bundle.js");
/**
 * Carga dinámicamente la API de Google Maps.
 * Usa callback para asegurar que google.maps.places esté disponible antes de continuar.
 */
function loadGoogleMapsAPI() {
    return new Promise((resolve, reject) => {
        var _a;
        if (typeof google !== 'undefined' && ((_a = google.maps) === null || _a === void 0 ? void 0 : _a.places)) {
            resolve();
            return;
        }
        const callbackName = 'googleMapsLoaded_' + Date.now();
        window[callbackName] = () => {
            delete window[callbackName];
            resolve();
        };
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places&v=3.64&callback=${callbackName}`;
        script.async = true;
        script.defer = true;
        script.onerror = () => {
            delete window[callbackName];
            reject(new Error('Failed to load Google Maps API'));
        };
        document.head.appendChild(script);
    });
}
function loadStep(stepName) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(`./views/${stepName}.html`);
        if (!response.ok) {
            throw new Error(`Failed to load ${stepName}: ${response.statusText}`);
        }
        const html = yield response.text();
        const container = document.getElementById('app-container');
        if (container) {
            container.innerHTML = html;
        }
        else {
            throw new Error('Container #app-container not found');
        }
    });
}
function init() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield loadGoogleMapsAPI();
            yield loadStep('step1');
            const { FormController } = yield Promise.resolve().then(() => __importStar(require('./core/FormController')));
            new FormController();
        }
        catch (error) {
            console.error('Error initializing application:', error);
        }
    });
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
}
else {
    init();
}
